module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Files/Folder-cloud-0e26f959d329d61e36ad4d3c27d4c123.svg";